import { render, staticRenderFns } from "./LibAuthHeader.vue?vue&type=template&id=d4dc8cc8&scoped=true"
import script from "./LibAuthHeader.vue?vue&type=script&lang=js"
export * from "./LibAuthHeader.vue?vue&type=script&lang=js"
import style0 from "./LibAuthHeader.vue?vue&type=style&index=0&id=d4dc8cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4dc8cc8",
  null
  
)

export default component.exports